import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { OrgEntry } from '../auth.model';

@Injectable({ providedIn: 'root' })
export class OidcOrgsCacheService {
    private subject = new BehaviorSubject<OrgEntry[]>([]);

    /** Emits once the org list has been loaded. Does not emit the empty initial value. */
    readonly orgs$: Observable<OrgEntry[]> = this.subject.asObservable().pipe(filter((orgs) => orgs.length > 0));

    set(orgs: OrgEntry[]): void {
        this.subject.next(orgs);
    }
}
